export default __webpack_public_path__ + "static/banner_1_1-33894288e6f8f88f489277b5493ec705.jpg";